import { useTranslation } from 'react-i18next'

import Spinner from 'components/Spinner/Spinner'

const PageLoader = () => {
  const { t } = useTranslation('common')
  return (
    <div id="page-loading" data-testid="page-loading">
      <Spinner label={t('page_loader')} />
    </div>
  )
}

export default PageLoader
